/* eslint-disable */
import {PpiAgreement} from './PpiAgreement';
import {BasePageModel} from './BasePageModel';
/**
* @description Interface for Avensia.Commerce.Web.src.views.PPI.PpiPageModel
*/
export interface PpiPageModel extends BasePageModel {
	agreements: PpiAgreement[];
}
export const isPpiPage = (model: unknown): model is PpiPageModel => (model as PpiPageModel).componentName === 'PpiPage';
